export var LightBoxEvents = {
    tries: 0,
    queueArray: [],
    acceptCookiePolicy: false,
    checkQueue: function() {
        var _this = this;

        if (!this.getDistinctUserHash()) {
            return false;
        }
        if (gon.requireCookieConsent && !this.acceptCookiePolicy) {
            // It's possible that the cookie policy gets denied after
            // this queue has started since the message is async.
            return;
        }

        _.each(this.queueArray, function(ob) {
            //if this user has a unique attribution window, override the default 30
            ob.obj.attribution_window = gon.current_account.extra_fields.attribution_window || 30;

            if (!ob.obj.distinct_user_hash) {
                ob.obj.distinct_user_hash = _this.getDistinctUserHash();

            }
            if (ob.cookieEvent) {
                _this.sendDataToParent(ob.obj, ob.cookieEvent);
            }
            if (gon.fingerprint && gon.fingerprint !== 'none') {
                ob.obj.fingerprint = gon.fingerprint;
            }
            if (gon.region_id) {
                ob.obj.region_id = gon.region_id;
            }

            _this.addKeenData(ob.obj);
            if (!_this.KeenClient && typeof Keen != 'undefined') {
                Keen.ready(function() {
                    _this.KeenClient = new Keen({
                        projectId: keen_project_id,
                        writeKey: keen_write_key,
                        host: gon.global.env.startsWith('staging') ? 'tinyrick.stag.pixlee.io' : 'tinyrick.pixlee.com'
                    });
                    _this.KeenClient.recordEvent(ob.event, ob.obj);
                });
            } else {
                _this.KeenClient.recordEvent(ob.event, ob.obj);
            }
        });
        this.queueArray = [];
    },
    getCookie: function(cname) {
        this._getCookieHelper(cname) || this._getCookieHelper(cname + '_legacy');
    },
    _getCookieHelper: function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    addKeenData: function(obj) {
        var addons = [];

        addons.push({
            name: 'keen:ip_to_geo',
            input: {
                ip: 'ip_address'
            },
            output: 'ip_geo_info'
        });

        obj.ip_address = gon.remote_ip;

        addons.push({
            name: 'keen:ua_parser',
            input: {
                ua_string: 'user_agent'
            },
            output: 'parsed_user_agent'
        });
        obj.user_agent = navigator.userAgent;

        addons.push({
            name: 'keen:url_parser',
            input: {
                url: 'page_url'
            },
            output: 'parsed_page_url'
        });
        obj.page_url = document.location.href;

        addons.push({
            name: 'keen:referrer_parser',
            input: {
                referrer_url: 'referrer_url',
                page_url: 'page_url'
            },
            output: 'referrer_info'
        });
        obj.referrer_url = document.referrer;
        obj.page_url = document.location.href;

        obj.keen = {
            addons: addons
        };
    },
    queueEvents: function() {
        var _this = this;
        setTimeout(function() {
            if (_this.queueArray.length > 0 && (!gon.requireCookieConsent || _this.acceptCookiePolicy)) {
                _this.checkQueue();
            }
            _this.queueEvents();
        }, 200);
    },
    sendDataToParent: function(obj, name) {
        var msg = {
            name: name,
            type: 'action',
            source: 'widget',
            destination: 'parent',
            data: obj
        };

        window.parent.postMessage(JSON.stringify(msg), '*');
    },
    OpenedPhoto: function(album_photo_id, contentSource, contentType, currentPage, direct_click, review, has_shoppable_badge) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.album_photo_id = album_photo_id;
        obj.currentDistilleryPage = currentPage;
        obj.direct_click = direct_click;
        obj.subcollection = 'Opened Lightbox';
        obj.contentSource = contentSource;
        obj.contentType = contentType;
        obj.review = review;
        obj.has_shoppable_badge = has_shoppable_badge;

        //add interacted
        var interacted_ob = {
            obj: obj,
            cookieEvent: 'pixlee:opened:photo',
            event: 'Interacted'
        };
        this.queueArray.push(interacted_ob);
    },
    ActionLinkLoaded: function(album_photo_id, links, rich_action) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.album_photo_id = album_photo_id;
        obj.links = !_.isFalsy(links) ? links : 1;
        if (rich_action) {
            obj.rich_action = true;
        }
        var ob = {
            obj: obj,
            event: 'Action Link Loaded'
        };
        this.queueArray.push(ob);
    },
    ActionLinkClicked: function(album_photo_id, action_link_url, action_text, rich_action, low_stock_shown, discount_pricing_shown) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.album_photo_id = album_photo_id;
        obj.action_link_url = action_link_url;
        obj.action_text = action_text;
        obj.low_stock_shown = low_stock_shown;
        obj.discount_pricing_shown = !!discount_pricing_shown;

        if (rich_action) {
            obj.rich_action = true;
        }
        if (gon.type === 'tap2shop') {
            obj.tap2shop = true;
        }
        //add interacted!
        obj.subcollection = 'Action Clicked';
        var interacted_ob = {
            obj: obj,
            event: 'Interacted'
        };
        this.queueArray.push(interacted_ob);
    },
    HotspotsClicked: function(album_photo_id) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.album_photo_id = album_photo_id;

        //add interacted!
        obj.subcollection = 'Hotspots Clicked';
        var interacted_ob = {
            obj: obj,
            event: 'Interacted'
        };

        this.queueArray.push(interacted_ob);
    },
    DownloadClicked: function(album_photo_id) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.album_photo_id = album_photo_id;
        obj.is_mobile = gon.isMobile || false;
        obj.is_tablet = gon.isTablet || false;

        //add interacted
        obj.subcollection = 'Download Clicked';
        var interacted_ob = {
            obj: obj,
            event: 'Interacted'
        };

        this.queueArray.push(interacted_ob);
    },
    PhotoShared: function(album_photo_id, platform) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.widget = this.widget;
        obj.album_photo_id = album_photo_id;
        obj.platform = platform;

        //add interacted
        obj.subcollection = 'Photo Shared';
        var interacted_ob = {
            obj: obj,
            event: 'Interacted'
        };
        this.queueArray.push(interacted_ob);
    },
    analyticsTrackClickReportButton: function(album_photo_id) {
        var obj = this.defaultProperties();
        obj.widget_config = this.defaultWidgetConfig();
        obj.album_photo_id = album_photo_id;
        obj.is_mobile = gon.isMobile || false;
        obj.is_tablet = gon.isTablet || false;

        //add interacted!
        obj.subcollection = 'Click Lightbox Report Button';
        var ob = {
            obj: obj,
            event: 'Interacted'
        };

        this.queueArray.push(ob);
    },
    defaultProperties: function() {
        var _this = this;
        var albumId = gon.current_photo ? gon.current_photo.album_id : gon.current_album.id;
        var publicationId = gon.current_photo ? null : (gon.recipe.filter_sort_id || gon.publication_id);
        var parentUrlParam = this.getParameterByName('parent_url', document.location.href);
        var properties = {
            album_id: albumId,
            account_id: gon.current_account.id,
            publication_id: publicationId,
            distinct_user_hash: this.getDistinctUserHash(),
            sortType: gon.sortType,
            widget: gon.widget,
            parentURL: parentUrlParam,
            baseParentURL: _.isTruthy(parentUrlParam) ? parentUrlParam.split(/[?#]/)[0] : null,
            widget_version: 'v4'
        };
        if (gon.current_album) {
            properties['album_type'] = gon.current_album.album_type;
        }
        if (gon.widget_id) {
            properties['widget_id'] = parseInt(gon.widget_id);
        }
        if (gon.widget_id_param) {
            properties['widget_id_param'] = parseInt(gon.widget_id_param);
        }
        if (gon.widget_type) {
            properties['widget_type'] = gon.widget_type;
        } else {
            properties['widget_type'] = "simple";
        }
        if (gon.fingerprint) {
            properties['fingerprint'] = gon.fingerprint;
        }
        if (gon.experiment_id && gon.experiment_group) {
            properties['experiment_id'] = gon.experiment_id;
            properties['experiment_group'] = gon.experiment_group;
        }
        return properties;
    },
    defaultWidgetConfig: function() {
        var _this = this;
        var lightbox;
        var uploaderButton = $('#upload_now');
        var displayOptions = gon.display_options;
        var headerOptions = displayOptions.headerOptions;
        var interactiveWidgetOptions = displayOptions.interactiveWidgetOptions;
        var interactiveWidgetTrack;
        var albumFilters = gon.recipe ? this.extractActiveFilters(gon.recipe.filters) : null;
        var isUploaderVisible = uploaderButton ? uploaderButton.css('display') !== 'none' : false;

        if (displayOptions.showCallToAction) {
            lightbox = 'CTA';
        } else {
            lightbox = 'default';
        }

        if (interactiveWidgetOptions) {
            interactiveWidgetTrack = {
                categories: interactiveWidgetOptions.categories,
                location: interactiveWidgetOptions.location,
                personalized: interactiveWidgetOptions.personalized,
                months: interactiveWidgetOptions.seasons,
                search: interactiveWidgetOptions.search,
                sort: interactiveWidgetOptions.sort,
                sortPopular: interactiveWidgetOptions.sortPopular,
                sortPrice: interactiveWidgetOptions.sortPrice,
                sortRecent: interactiveWidgetOptions.sortRecent,
                widgetType: interactiveWidgetOptions.widgetType,
                interactiveWidgetType: interactiveWidgetOptions.interactiveWidgetType,
                numOfCategories: interactiveWidgetOptions.selectedCategories ? interactiveWidgetOptions.selectedCategories.length : 0,
                selectedCategories: interactiveWidgetOptions.selectedCategories
            };
        }

        var properties = {
            interactiveWidgetOptions: interactiveWidgetTrack || false,
            interactive_social_hub: displayOptions.is_interactive || false,
            interactive_social_hub_type: interactiveWidgetOptions ? interactiveWidgetOptions.interactiveWidgetType : false,
            header_layout: headerOptions ? headerOptions.layout : false,
            uploader: isUploaderVisible,
            uploader_button_style: headerOptions ? headerOptions.button : false,
            lightbox: lightbox,
            theme: displayOptions.css_preset_filename || displayOptions.css_preset_filename_v2 || '',
            mobile_optimization: displayOptions.showViewport || false,
            load_priority: displayOptions.speedOptimization || false,
            album_filters: albumFilters,
            end_tile_uploader: headerOptions && headerOptions.end_tile_upload_button_background_showHide ? headerOptions.end_tile_upload_button_background_showHide : false
        };

        return properties;
    },
    extractActiveFilters: function(obj) {
        /*There are 3 types of filters: "simple" (boolean/string), object and array. we want to keep the following:
            (1) All non-falsy "simple" filters (i.e. true booleans and non empty strings)
            (2) All objects contain at least one array in them. We want objects where at least one of this has elements in it
            (3) All Arrays with length > 0
        */
        var result = {};

        //can't use _.filter because we need to preserve the key too not just the value
        _.each(obj, function(prop, key) {
            var success = false;

            if (Array.isArray(prop)) {
                success = prop.length > 0;
            } else if (typeof prop === 'object') {
                var arraySize = 0;

                //sum the length of all subproperties (they are all strings or arrays) and return if total length > 0
                _.each(prop, function(subProp) {
                    //check that it has a length just in case we add something other than a string or array later
                    arraySize += subProp.length ? subProp.length : 0;
                });

                success = arraySize > 0;
            } else {
                success = !prop;
            }

            if (success) {
                result[key] = prop;
            }
        });

        return result;
    },
    getDistinctUserHash: function() {
        if (typeof analytics !== 'undefined' && analytics.getAnonymousId) {
            return analytics.getAnonymousId();
        } else {
            var msg = {
                name: 'pixlee:log:to:sentry',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    messageText: 'Failed to retrieve DUH',
                    messageExtraFields: {
                        tags: {
                            source: 'widgets',
                            analytics: typeof analytics !== 'undefined',
                            file: 'lightbox_events.js'
                        }
                    }
                }
            };
            //window.parent.postMessage(JSON.stringify(msg), '*');
        }
    },
    getTime: function() {
        return Date.now();
    },
    getParameterByName: function(name, url) {
        name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(url);
        return results == null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
};
if (_.isFalsy(gon.previewMode)) {
    window.addEventListener('message', function(event) {
        var eventData;
        if (event.data) {
            try {
                eventData = JSON.parse(event.data);
            } catch (error) {
                // Some other way of sending data, ignore
                return;
            }
        } else {
            return;
        }

        if (eventData.name) {
            if (eventData.name === 'pixlee:fingerprint') {
                gon.fingerprint = eventData.data;
                LightBoxEvents.queueEvents();
            } else if (eventData.name === 'pixlee:cookie') {
                LightBoxEvents.acceptCookiePolicy = eventData.data;
                gon.acceptCookiePolicy = eventData.data;
            }
        }

    }.bind(this));

    var getFingerprintMessage = {
        name: 'pixlee:get:fingerprint:from:parent',
        type: 'action',
        destination: 'all',
        source: '',
        data: {}
    }

    var getCookieMessage = {
        name: 'pixlee:get:cookie:from:parent',
        type: 'action',
        destination: 'all',
        source: '',
        data: {}
    }

    window.parent.postMessage(JSON.stringify(getFingerprintMessage), '*');
    window.parent.postMessage(JSON.stringify(getCookieMessage), '*');
}
